import React, {useMemo} from 'react'
import {Outlet} from "react-router-dom"
import ProjectSidebar from "./Nav/ProjectSidebar"
import {ProjectProvider, useProjectData} from "../../hooks/useProjectData"
import ProjectLayoutContainer from "./ProjectLayoutContainer"
import ActivitySidebar from "../projects/ActivitySidebar"
import RightSidebar from "./RightSidebar"
import BreadcrumbsLayer from "./Nav/BreadcrumbsLayer"
import ProjectCrumb from "./Nav/ProjectCrumb"
import {BreadcrumbItem} from "./Nav/BreadcrumbsProvider"

function ProjectLayout() {
    return (
        <ProjectProvider>
            <ProjectLayoutInner/>
        </ProjectProvider>
    )
}

function ProjectLayoutInner() {
    const {id, project} = useProjectData()

    const items = useMemo<BreadcrumbItem[]>(() => [{
        render: <ProjectCrumb projectId={id} name={project?.name}/>,
        key: project?.name ?? "",
    }], [id, project?.name])

    return (
        <BreadcrumbsLayer items={items}>
            <ProjectSidebar/>
            <ProjectLayoutContainer>
                <Outlet/>
            </ProjectLayoutContainer>
            <RightSidebar>
                <ActivitySidebar/>
            </RightSidebar>
        </BreadcrumbsLayer>
    )
}

export default ProjectLayout
